import { action, makeAutoObservable, toJS } from "mobx";
import { PartialBlock } from "@blocknote/core";
import { NotesView, SaveNotesPayload } from "../pages/notes/Notes.type";

type Attachment = {
  attachements: {
    location: string;
    name: string;
    type: string;
    path: string;
  }[];
  audio: {
    url: string;
    name: string;
    type: string;
  }[];
  noteID?: number;
};

type NoteAttachment = {
  location: string;
  name: string;
  type: string;
  path: string;
}[];

export class NotesStore {
  getNotes: any = {};
  searchnotes = "";
  notesview: NotesView | null = null;

  updatedNotes: any = {};
  notesAttachment: NoteAttachment = [];

  defaultpayloadSaveNotes: SaveNotesPayload = {
    projectid: 1,
    title: "Test",
    scope: "project",
    ref_str: "",
    ref_partition: "",
    searchtext:
      "Testing richtextnote for storing information passed by frontend",
    tags: ["Water"],
    richtext: { editorContent: [] },
  };

  attachment: Attachment = {
    attachements: [],
    audio: [],
  };

  noteList: any = {};

  resetNotes() {
    this.attachment = {
      attachements: [],
      audio: [],
    };
  }

  get notesArray() {
    return Object.entries(toJS(this.getNotes || {}));
  }

  get totalNotes() {
    return this.notesArray.length;
  }

  showAttachementsModal: boolean = false;
  activeTab: string = "Attachments";
  constructor() {
    makeAutoObservable(this);
  }
  @action
  setNotes(newNotes) {
    this.attachment = { ...this.attachment, ...newNotes };
  }
  @action
  toggleAttachmentsModal = () => {
    this.showAttachementsModal = !this.showAttachementsModal;
    console.log(this.showAttachementsModal);
  };
  @action
  setActiveTab = (tab: string) => {
    this.activeTab = tab;
  };

  // set notes geting from getnotes api
  @action
  setGetNotes = (nots) => {
    this.getNotes = nots;
  };

  setSearchNotes = (searchvalue) => {
    this.searchnotes = searchvalue;
  };

  setNotesViewData = (notesview) => {
    this.notesview = toJS({
      ...notesview,
    });
  };
  @action
  setAttachment = (attachment) => {
    console.log(attachment);
    // ✅ Skip if it's empty, null, or undefined
    if (
      !attachment ||
      (typeof attachment === "object" && Object.keys(attachment).length === 0)
    ) {
      return;
    }

    // ✅ Ensure current is always a flat array
    const current = Array.isArray(this.notesAttachment)
      ? this.notesAttachment.flat(Infinity)
      : [];

    // ✅ Flatten the new attachment if it’s an array of arrays
    const newAttachments = Array.isArray(attachment)
      ? attachment.flat(Infinity)
      : [attachment];

    // ✅ Combine and remove duplicates (optional but safer)
    const merged = [...current, ...newAttachments].filter(
      (item, index, self) =>
        item &&
        self.findIndex((f) => f.path === item.path && f.name === item.name) ===
          index
    );

    this.notesAttachment = merged;

    console.log("📎 Updated attachments:", toJS(this.notesAttachment));
  };

  @action
  removeAttachment = (fileToRemove) => {
    this.notesAttachment = this.notesAttachment.filter(
      (file) =>
        file.name !== fileToRemove.name || file.path !== fileToRemove.path
    );

    console.log("📎 After delete, attachments:", toJS(this.notesAttachment));
  };
}
